import gql from 'graphql-tag';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';
import PRODUCT_FRAGMENT from 'graph/fragments/product';

const GET_USER_CLASSROOM_STATS = gql`
  query getUserStats($id: Int!) {
    user(where: { id: $id }) {
      id
      firstName
      lastName
      organizationAssociations {
        organization {
          id
          name
          type
        }
      }
      classroomEnrollments {
        classroom {
          id
          licenseUsage {
            productId
            assignedCount
            product {
              ...BaseProduct
            }
          }
          stats {
            ...BaseClassroomStats
          }
        }
      }
    }
  }
  ${PRODUCT_FRAGMENT}
  ${CLASSROOM_STATS_FRAGMENT}
`;

export default GET_USER_CLASSROOM_STATS;
